import { useEffect } from "react";
import {
  Typography,
  FormControlLabel,
  Box,
  IconButton,
  CircularProgress,
  Button,
} from "@mui/material";
import Select from "react-select";
import DoneIcon from "@mui/icons-material/Done";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { axiosInstance } from "../../utility/apiInstance";
const SubscriptionForm = ({
  setmodalPopup,
  subscriptionFormData,
  manageContactList,
  setSubscriptionFormData,
  type,
  subscriptionList,
  whatsappGroupList,
  loading,
  addSubscription,
  editable,
  editData,
  getAllMileStone,
}: any) => {
  useEffect(() => {
    if (Object.keys(editData)?.length === 0) {
      manageTemplate();
    }
    getContactList("");
    if (type === "Awb") {
      getAllAirBill();
    }
    whatsappGroup();
    getAllMasterCustomerOrganization()
  }, []);

  const getContactList = async (masterOrganizationId:string) => {
    try {
      let response = await axiosInstance.get("/api/v1/contact");
      if(masterOrganizationId){
        response = await axiosInstance.get(`/api/v1/contact/${masterOrganizationId}`);
      }
      setSubscriptionFormData((prev: any) => {
        return {
          ...prev,
          manageContactList: response?.data?.data,
        };
      });
    } catch (err: any) {
       setSubscriptionFormData((prev: any) => {
        return {
          ...prev,
          manageContactList: []
        };
      });
    }
  };
  const getAllMasterCustomerOrganization = async () => {
    try {
      let {data} = await axiosInstance.get("/api/v1/master-contact-organization");
     
      setSubscriptionFormData((prev: any) => {
        return {
          ...prev,
          masterContactOrgnization: data?.data,
        };
      });
    } catch (err: any) {
      setSubscriptionFormData((prev:any)=>(
        {
          ...prev,
          masterContactOrgnization:[]
        }
      ))
    }
  };

  const getAllAirBill = async () => {
    try {
      let response = await axiosInstance.get("/api/v1/airwaybill/get-awb");
      setSubscriptionFormData((prev: any) => {
        return {
          ...prev,
          subscriptionList: response?.data?.data,
        };
      });
    } catch (err) {
      setSubscriptionFormData((prev: any) => {
        return {
          ...prev,
          subscriptionList: [],
        };
      });
    }
  };

  const manageTemplate = async () => {
    try {
      let response = await axiosInstance.get("/api/v1/subscription-template");
      setSubscriptionFormData((prev: any) => {
        return {
          ...prev,
          templateList: response?.data?.data,
        };
      });
    } catch (err) {
      setSubscriptionFormData((prev: any) => {
        return {
          ...prev,
          templateList:[],
        };
      });
    }
  };

  const whatsappGroup = async () => {
    try {
      let response = await axiosInstance.get("/api/v1/whatsapp-group");
      setSubscriptionFormData((prev: any) => {
        return {
          ...prev,
          whatsappGroupList: response?.data?.data,
        };
      });
    } catch (error) {

      setSubscriptionFormData((prev: any) => {
        return {
          ...prev,
          whatsappGroupList: [],
        };
      });
    }
  };
  return (
    <Box className="modalTracking" sx={{ width: "100%", maxWidth: "100%", margin: "auto", padding: 4 }}>
      {Object.keys(editData)?.length === 0 && (
        <>
          <div className="mb-3">
            <FormControlLabel 
              className="labelTracking"
              control={<DoneIcon />}
              label={<Typography variant="h6">Choose a Template</Typography>}
            />
            <Select
              name="templateName"
              options={subscriptionFormData?.templateList?.map((item: any) => ({
                label: item?.templateName,
                value: item?._id,
              }))}
              placeholder="Choose Template"
              className="basic-multi-select"
              classNamePrefix="select"
              value={subscriptionFormData?.templateName}
              onChange={(option: any) => {
                let findEmailMileStone = subscriptionFormData.templateList?.find(
                  (item: any) => item?._id === option?.value
                );
                setSubscriptionFormData((prev: any) => {
                  return {
                    ...prev,
                    whatsApp: findEmailMileStone?.waContacts?.map(
                      (item: any) => ({
                        label: `${item?.salutation}. ${item?.name} (${item?.countryCode}${item?.whatappNumber}, ${item?.masterContactOrganization?.name})`,
                        value: item._id,
                      })
                    ),
                    emails: findEmailMileStone?.emailContacts.map(
                      (item: any) => ({
                        label: `${item?.salutation}. ${item?.name} (${item?.email}, ${item?.masterContactOrganization?.name})`,
                        value: item._id,
                      })
                    ),
                    whatsAppgroups: findEmailMileStone?.whatsappGroups?.map(
                      (item: any) => ({
                        label: `${item?.name}`,
                        value: item._id,
                      })
                    ),
                    whatsAppmilestones:
                      findEmailMileStone?.waMilestones?.map(
                        (milestone: any) => milestone._id
                      ) || [],

                    emailsmilestones:
                      findEmailMileStone?.emailMilestones?.map(
                        (milestone: any) => milestone._id
                      ) || [],

                      whatsappGroupmilestones:
                      findEmailMileStone?.whatsappGroupMilestones?.map(
                        (milestone: any) => milestone._id
                      ) || [],

                    templateName: option,
                  };
                });
              }}
              styles={{
                control: (base) => ({
                  ...base,
                  backgroundColor: "#f0f0f0",
                  border: "none",
                  boxShadow: "none",
                  "&:hover": {
                    border: "none",
                  },
                }),
                placeholder: (base) => ({
                  ...base,
                  color: "#999",
                }),
              }}
            />
          </div>
        </>
      )}
      
      
      
      <Box sx={{ mb: 0 }}>
        {type === "Awb" && (
          <>
            <div className="mb-3">
              <FormControlLabel
                className="labelTracking"
                control={<DoneIcon />}
                label={<Typography variant="h6">AWB</Typography>}
              />
              <Select
                isMulti={false}
                isDisabled={editable}
                name="awb"
                options={subscriptionList?.map((item: any) => ({
                  label: item?.awbNumber,
                  value: item.awbNumber,
                }))}
                placeholder="Enter AWBs"
                className="basic-multi-select"
                classNamePrefix="select"
                value={subscriptionFormData.awbs}
                onChange={(option: any) => {
                  getAllMileStone(option.value).then((res: any) => {
                    setSubscriptionFormData((prev: any) => {
                      return {
                        ...prev,
                        awbs: option,
                      };
                    });
                  });
                }}
                styles={{
                  control: (base) => ({
                    ...base,
                    backgroundColor: "#f0f0f0",
                    border: "none",
                    boxShadow: "none",
                    "&:hover": {
                      border: "none",
                    },
                  }),
                  placeholder: (base) => ({
                    ...base,
                    color: "#999",
                  }),
                }}
              />
            </div>
          </>
        )}
      </Box>

       <>
        <div className="mb-3">
            <FormControlLabel
              className="labelTracking"
              control={<DoneIcon />}
              label={<Typography variant="h6">Select organization</Typography>}
            />
            <Select
              name="masterOrganization"
              options={subscriptionFormData?.masterContactOrgnization?.map((item: any) => ({
                label: item?.name,
                value: item?._id,
              }))}
              placeholder="Select organization"
              className="basic-multi-select"
              classNamePrefix="select"
              value={subscriptionFormData?.masterOrganization}
              onChange={(option: any) => {
                let findEmailMileStone = subscriptionFormData.masterContactOrgnization?.find(
                  (item: any) => item?._id === option?.value
                );
              getContactList(findEmailMileStone?._id||"")
              }}
              styles={{
                control: (base) => ({
                  ...base,
                  backgroundColor: "#f0f0f0",
                  border: "none",
                  boxShadow: "none",
                  "&:hover": {
                    border: "none",
                  },
                }),
                placeholder: (base) => ({
                  ...base,
                  color: "#999",
                }),
              }}
            />
          </div>
        </>
      {editData?.row?.alertType === "whatsapp" ? (
        <>
        <div className="mb-3">
          <FormControlLabel
            className="labelTracking"
            sx={{ mt: 2 }}
            control={<DoneIcon />}
            label={<Typography variant="h6">WhatsApp</Typography>}
          />
          <Select
            isMulti
            name="whatsapp-users"
            options={manageContactList
              ?.filter((item: any) => item.isActive && item?.whatappNumber&&(item?.allowedChannels||[]).includes("whatsapp"))
              .map((item: any) => ({
                label: `${item?.salutation}. ${item?.name} (${item?.countryCode}${item?.whatappNumber}, ${item?.organizationName})`,
                value: item._id,
              }))}
            placeholder="Enter Users"
            className="basic-multi-select"
            classNamePrefix="select"
            value={subscriptionFormData.whatsApp}
            onChange={(option: any) => {
              setSubscriptionFormData((prev: any) => {
                return {
                  ...prev,
                  whatsApp: option,
                };
              });
            }}
            styles={{
              control: (base) => ({
                ...base,
                backgroundColor: "#f0f0f0",
                border: "none",
                boxShadow: "none",
                "&:hover": {
                  border: "none",
                },
              }),
              placeholder: (base) => ({
                ...base,
                color: "#999",
              }),
            }}
          />
          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1 }}>
            <Typography variant="body2" color="textSecondary">
              Include/Exclude milestone{" "}
              {subscriptionFormData?.whatsAppmilestones.length > 0
                ? `${subscriptionFormData?.whatsAppmilestones.length} / ${subscriptionFormData?.milestoneList.length} selected`
                : null}{" "}
              <IconButton
                onClick={() => {
                  setmodalPopup((prev: any) => ({
                    ...prev,
                    subcriptionPopup: false,
                    mileStonePopup: true,
                  }));
                  setSubscriptionFormData((prev: any) => {
                    return {
                      ...prev,
                      mileStoneType: "whatsApp",
                    };
                  });
                }}
              >
                <KeyboardArrowDownIcon />
              </IconButton>
            </Typography>
          </Box>
        </div>
        </>
      ) : Object.keys(editData)?.length === 0 ? (
        <>
          <div className="mb-3">
            <FormControlLabel 
              className="labelTracking"
              control={<DoneIcon />}
              label={<Typography variant="h6">WhatsApp</Typography>}
            />
            <Select
              isMulti
              name="whatsapp-users"
              options={manageContactList
                ?.filter((item: any) => item.isActive && item?.whatappNumber&&(item?.allowedChannels||[]).includes("whatsapp"))
                .map((item: any) => ({
                  label: `${item?.salutation}. ${item?.name} (${item?.countryCode}${item?.whatappNumber}, ${item?.masterContactOrganization?.name})`,
                  value: item._id,
                }))}
              placeholder="Enter Users"
              className="basic-multi-select"
              classNamePrefix="select"
              value={subscriptionFormData.whatsApp}
              onChange={(option: any) => {
                setSubscriptionFormData((prev: any) => {
                  return {
                    ...prev,
                    whatsApp: option,
                  };
                });
              }}
              styles={{
                control: (base) => ({
                  ...base,
                  backgroundColor: "#f0f0f0",
                  border: "none",
                  boxShadow: "none",
                  "&:hover": {
                    border: "none",
                  },
                }),
                placeholder: (base) => ({
                  ...base,
                  color: "#999",
                }),
              }}
            />
            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1 }}>
              <Typography variant="body2" color="textSecondary">
                Include/Exclude milestone{" "}
                {(subscriptionFormData?.
                  whatsAppmilestones||[]).length > 0
                  ? `${(subscriptionFormData?.
                  whatsAppmilestones||[]).length} / ${(subscriptionFormData?.milestoneList||[]).length} selected`
                  : null}{" "}
                <IconButton
                  onClick={() => {
                    setmodalPopup((prev: any) => ({
                      ...prev,
                      subcriptionPopup: false,
                      mileStonePopup: true,
                    }));
                    setSubscriptionFormData((prev: any) => {
                      return {
                        ...prev,
                        mileStoneType: "whatsApp",
                      };
                    });
                  }}
                >
                  <KeyboardArrowDownIcon />
                </IconButton>
              </Typography>
            </Box>
          </div>
        </>
      ) : (
        <></>
      )}
      <Box sx={{ mt: 0 }}>
        {editData?.row?.alertType === "email" ? (
          <>
            <div className="mb-3">
              <FormControlLabel
                className="labelTracking"
                control={<DoneIcon />}
                label={<Typography variant="h6">Email</Typography>}
              />
              <Select
                isMulti
                name="Email"
                placeholder="Select..."
                className="basic-multi-select"
                classNamePrefix="select"
                options={manageContactList
                  ?.filter((item: any) => item.isActive && item?.email&&(item?.allowedChannels||[]).includes("email"))
                  .map((item: any) => ({
                    label: `${item?.salutation}. ${item?.name} (${item?.email}, ${item?.masterContactOrganization?.name})`,
                    value: item._id,
                  }))}
                value={subscriptionFormData.emails}
                onChange={(option: any) => {
                  setSubscriptionFormData((prev: any) => {
                    return {
                      ...prev,
                      emails: option,
                    };
                  });
                }}
                styles={{
                  control: (base) => ({
                    ...base,
                    backgroundColor: "#f0f0f0",
                    border: "none",
                    boxShadow: "none",
                    "&:hover": {
                      border: "none",
                    },
                  }),
                  placeholder: (base) => ({
                    ...base,
                    color: "#999",
                  }),
                }}
              />
              <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1 }}>
                <Typography variant="body2" color="textSecondary">
                  Include/Exclude milestone{" "}
                  {(subscriptionFormData?.emailsmilestones||[]).length > 0
                    ? `${(subscriptionFormData?.emailsmilestones||[]).length} / ${(subscriptionFormData?.milestoneList||[]).length} selected`
                    : null}{" "}
                  <IconButton
                    onClick={() => {
                      setmodalPopup((prev: any) => ({
                        ...prev,
                        subcriptionPopup: false,
                        mileStonePopup: true,
                      }));
                      setSubscriptionFormData((prev: any) => {
                        return {
                          ...prev,
                          mileStoneType: "emails",
                        };
                      });
                    }}
                  >
                    <KeyboardArrowDownIcon />
                  </IconButton>
                </Typography>
              </Box>
            </div>
          </>
        ) : editData && Object.keys(editData)?.length === 0 ? (
          <>
            <div className="mb-3">
              <FormControlLabel
                className="labelTracking"
                control={<DoneIcon />}
                label={<Typography variant="h6">Email</Typography>}
              />
              <Select
                isMulti
                name="Email"
                placeholder="Select..."
                className="basic-multi-select"
                classNamePrefix="select"
                options={manageContactList
                  ?.filter((item: any) => item.isActive && item?.email&&(item?.allowedChannels||[]).includes("email"))
                  .map((item: any) => ({
                    label: `${item?.salutation}. ${item?.name} (${item?.email}, ${item?.organizationName})`,
                    value: item._id,
                  }))}
                value={subscriptionFormData.emails}
                onChange={(option: any) => {
                  setSubscriptionFormData((prev: any) => {
                    return {
                      ...prev,
                      emails: option,
                    };
                  });
                }}
                styles={{
                  control: (base) => ({
                    ...base,
                    backgroundColor: "#f0f0f0",
                    border: "none",
                    boxShadow: "none",
                    "&:hover": {
                      border: "none",
                    },
                  }),
                  placeholder: (base) => ({
                    ...base,
                    color: "#999",
                  }),
                }}
              />
              <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1 }}>
                <Typography variant="body2" color="textSecondary">
                  Include/Exclude milestone{" "}
                  {(subscriptionFormData?.emailsmilestones||[]).length > 0
                    ? `${(subscriptionFormData?.emailsmilestones||[]).length} / ${(subscriptionFormData?.milestoneList||[]).length} selected`
                    : null}{" "}
                  <IconButton
                    onClick={() => {
                      setmodalPopup((prev: any) => ({
                        ...prev,
                        subcriptionPopup: false,
                        mileStonePopup: true,
                      }));
                      setSubscriptionFormData((prev: any) => {
                        return {
                          ...prev,
                          mileStoneType: "emails",
                        };
                      });
                    }}
                  >
                    <KeyboardArrowDownIcon />
                  </IconButton>
                </Typography>
              </Box>
            </div>
          </>
        ) : null}

        {editData?.row?.alertType === "whatsappgroup" ? (
          <>
            <div className="mb-3">
              <FormControlLabel
                className="labelTracking"
                control={<DoneIcon />}
                label={<Typography variant="h6">WhatsApp Group</Typography>}
              />
              <Select
                isMulti
                name="whatsapp-group"
                options={whatsappGroupList
                  ?.filter((item: any) => item?.name)
                  .map((item: any) => ({
                    label: `${item?.name}`,
                    value: item._id,
                  }))}
                placeholder="Enter Group"
                className="basic-multi-select"
                classNamePrefix="select"
                value={subscriptionFormData.whatsAppgroups}
                onChange={(option: any) => {
                  setSubscriptionFormData((prev: any) => {
                    return {
                      ...prev,
                      whatsAppgroups: option,
                    };
                  });
                }}
                styles={{
                  control: (base) => ({
                    ...base,
                    backgroundColor: "#f0f0f0",
                    border: "none",
                    boxShadow: "none",
                    "&:hover": {
                      border: "none",
                    },
                  }),
                  placeholder: (base) => ({
                    ...base,
                    color: "#999",
                  }),
                }}
              />
              <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1 }}>
                <Typography variant="body2" color="textSecondary">
                  Include/Exclude milestone{" "}
                  {(subscriptionFormData?.whatsappGroupmilestones||[]).length > 0
                    ? `${(subscriptionFormData?.whatsappGroupmilestones||[]).length} / ${(subscriptionFormData?.milestoneList||[]).length} selected`
                    : null}{" "}
                  <IconButton
                    onClick={() => {
                      setmodalPopup((prev: any) => ({
                        ...prev,
                        subcriptionPopup: false,
                        mileStonePopup: true,
                      }));
                      setSubscriptionFormData((prev: any) => {
                        return {
                          ...prev,
                          mileStoneType: "whatsappGroup",
                        };
                      });
                    }}
                  >
                    <KeyboardArrowDownIcon />
                  </IconButton>
                </Typography>
              </Box>
            </div>
          </>
        ) : Object.keys(editData)?.length === 0 ? (
          <>
            <div className="mb-3">
              <FormControlLabel
                className="labelTracking"
                control={<DoneIcon />}
                label={<Typography variant="h6">WhatsApp Group</Typography>}
              />
              <Select
                isMulti
                name="whatsapp-users"
                options={whatsappGroupList
                  ?.filter((item: any) => item?.name)
                  .map((item: any) => ({
                    label: `${item?.name}`,
                    value: item._id,
                  }))}
                placeholder="Enter Groups"
                className="basic-multi-select"
                classNamePrefix="select"
                value={subscriptionFormData.whatsAppgroups}
                onChange={(option: any) => {
                  setSubscriptionFormData((prev: any) => {
                    return {
                      ...prev,
                      whatsAppgroups: option,
                    };
                  });
                }}
                styles={{
                  control: (base) => ({
                    ...base,
                    backgroundColor: "#f0f0f0",
                    border: "none",
                    boxShadow: "none",
                    "&:hover": {
                      border: "none",
                    },
                  }),
                  placeholder: (base) => ({
                    ...base,
                    color: "#999",
                  }),
                }}
              />
              <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1 }}>
                <Typography variant="body2" color="textSecondary">
                  Include/Exclude milestone{" "}
                  {(subscriptionFormData?.whatsappGroupmilestones||[]).length > 0
                    ? `${(subscriptionFormData?.whatsappGroupmilestones||[]).length} / ${(subscriptionFormData?.milestoneList||[]).length} selected`
                    : null}{" "}
                  <IconButton
                    onClick={() => {
                      setmodalPopup((prev: any) => ({
                        ...prev,
                        subcriptionPopup: false,
                        mileStonePopup: true,
                      }));
                      setSubscriptionFormData((prev: any) => {
                        return {
                          ...prev,
                          mileStoneType: "whatsappGroup",
                        };
                      });
                    }}
                  >
                    <KeyboardArrowDownIcon />
                  </IconButton>
                </Typography>
              </Box>
            </div>
          </>
        ) : (
          <></>
        )}

        {type === "Awb" && (
          <Button
            className="btn btnTheme"
            variant="outlined"
            disabled={!subscriptionFormData?.awbs || subscriptionFormData?.awbs.length === 0 || loading}
            onClick={addSubscription}
            sx={{
              opacity: !subscriptionFormData?.awbs || subscriptionFormData?.awbs.length === 0 ? 0.5 : 1,
              cursor: !subscriptionFormData?.awbs || subscriptionFormData?.awbs.length === 0 ? "not-allowed" : "pointer",
              transition: "opacity 0.3s ease",
            }}
          >
            {loading ? (
              <CircularProgress size={24} color="inherit" />
            ) : editable ? (
              "Update"
            ) : (
              "Submit"
            )}
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default SubscriptionForm;
